import { render, staticRenderFns } from "./StudentInformation.vue?vue&type=template&id=30d5a424&"
import script from "./StudentInformation.vue?vue&type=script&lang=js&"
export * from "./StudentInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports